import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {
        const splideElements = document.querySelectorAll('.reviews-slider__slider.splide');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                const options = JSON.parse(splideElement.getAttribute('data-splide'));
                const splide = new Splide(splideElement, options);
                splide.mount();

                const applyArcEffect = () => {
                    const slides = splide.root.querySelectorAll('.review-image img');
                    const total = slides.length;
                    if (total === 0) return;
                    const maxAngle = 20;
                    const maxOffset = 20;
                    slides.forEach((img, i) => {
                        const offset = i - (total - 1) / 2;
                        const angle = offset * (maxAngle / total);
                        const y = Math.abs(offset) * (maxOffset / total) * 2;
                        img.style.transform = `translateY(${y}px) rotate(${angle}deg)`;
                    });
                };

                splide.on('mounted move', applyArcEffect);
            });
        }
    };
    
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=reviews-slider', initializeBlock);
    } else {
        initializeBlock();
    }
});
